<template>
  <v-navigation-drawer v-model="drawer" width="290" :mini-variant.sync="mini" color="primary" dark app fixed>
    <v-list class="pa-0 ma-0 white--text">
      <v-list-item link to='/dashboard' exact>
        <v-list-item-icon><v-icon>mdi-home</v-icon></v-list-item-icon>
        <v-list-item-content><v-list-item-title class="font-weight-medium">Inicio</v-list-item-title></v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider></v-divider>
    <!-- ADMINISTRACIÓN -->
    <v-list
        class="pa-0 ma-0 white--text"
        v-if="($can('Administración - Usuarios') || $can('Administración - Roles') || $can('Administración - AFP') || $can('Administración - Cargos') || $can('Administración - EPS') || $can('Administración - Tipos de Contrato') || $can('Administración - Tipos de Documento') || $can('Administración - Clientes'))"
    >
      <v-subheader class="third--text font-weight-medium">Administración</v-subheader>
      <v-divider inset></v-divider>
      <v-list-item link to='/admin/clients' v-if="$can('Administración - Clientes')">
        <v-list-item-icon><v-icon>mdi-account-switch</v-icon></v-list-item-icon>
        <v-list-item-content><v-list-item-title class="font-weight-medium">Clientes</v-list-item-title></v-list-item-content>
      </v-list-item>
      <v-list-item link to='/admin/users' v-if="$can('Administración - Usuarios')">
        <v-list-item-icon><v-icon>mdi-account-group</v-icon></v-list-item-icon>
        <v-list-item-content><v-list-item-title class="font-weight-medium">Usuarios</v-list-item-title></v-list-item-content>
      </v-list-item>
      <!--  <v-list-item link to='/admin/roles' v-if="$can('Administración - Roles')">
           <v-list-item-icon><v-icon>mdi-account-key</v-icon></v-list-item-icon>
           <v-list-item-content><v-list-item-title class="font-weight-medium">Roles y permisos</v-list-item-title></v-list-item-content>
       </v-list-item> -->
      <!-- PARÁMETROS -->
      <v-list-group
          :value="false"
          prepend-icon="mdi-cog-outline"
          color="white"
          no-action
          v-if="($can('Administración - AFP') || $can('Administración - Cargos') || $can('Administración - EPS') || $can('Administración - Tipos de Contrato') || $can('Administración - Tipos de Documento') || $can('Administración - Referencias Cartas Diarias') || $can('Administración - Razones Cartas Diarias') || $can('Administración - Géneros Ausentes Cartas Diarias'))"
      >
        <template v-slot:activator>
          <v-list-item-title class="font-weight-medium">Parámetros</v-list-item-title>
        </template>
        <v-list-item link to='/admin/professional-insurances' v-if="$can('Administración - AFP')">
          <v-list-item-content><v-list-item-title class="font-weight-medium">AFP</v-list-item-title></v-list-item-content>
        </v-list-item>
        <v-list-item link to='/admin/job-titles' v-if="$can('Administración - Cargos')">
          <v-list-item-content><v-list-item-title class="font-weight-medium">Cargos</v-list-item-title></v-list-item-content>
        </v-list-item>
        <v-list-item link to='/admin/health-insurances' v-if="$can('Administración - EPS')">
          <v-list-item-content><v-list-item-title class="font-weight-medium">EPS</v-list-item-title></v-list-item-content>
        </v-list-item>
        <v-list-item link to='/admin/contract-types' v-if="$can('Administración - Tipos de Contrato')">
          <v-list-item-content><v-list-item-title class="font-weight-medium">Tipos de Contrato</v-list-item-title></v-list-item-content>
        </v-list-item>
        <v-list-item link to='/admin/document-types' v-if="$can('Administración - Tipos de Documento')">
          <v-list-item-content><v-list-item-title class="font-weight-medium">Tipos de Documento</v-list-item-title></v-list-item-content>
        </v-list-item>
        <v-list-item link to='/admin/daily-letters-references' v-if="$can('Administración - Referencias Cartas Diarias')">
          <v-list-item-content><v-list-item-title class="font-weight-medium">Referencias (Cartas)</v-list-item-title></v-list-item-content>
        </v-list-item>
        <v-list-item link to='/admin/daily-letters-reasons' v-if="$can('Administración - Razones Cartas Diarias')">
          <v-list-item-content><v-list-item-title class="font-weight-medium">Razones (Cartas)</v-list-item-title></v-list-item-content>
        </v-list-item>
        <v-list-item link to='/admin/daily-letters-absent-genders' v-if="$can('Administración - Géneros Ausentes Cartas Diarias')">
          <v-list-item-content><v-list-item-title class="font-weight-medium">Géneros Ausentes (Cartas)</v-list-item-title></v-list-item-content>
        </v-list-item>
        <v-list-item link to='/admin/settings' v-if="$can('Administración - Configuración')">
          <v-list-item-content><v-list-item-title class="font-weight-medium">Configuración</v-list-item-title></v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>
    <!-- CLIENTES -->
    <v-list class="pa-0 ma-0 white--text" v-if="($can('Clientes - Certificados') || $can('Clientes - Documentos Revisor Fiscal'))">
      <v-subheader class="third--text font-weight-medium">Clientes</v-subheader>
      <v-divider inset></v-divider>
      <v-list-item link to='/client/employees' v-if="$can('Clientes - Certificados')">
        <v-list-item-icon><v-icon>mdi-account-multiple-check</v-icon></v-list-item-icon>
        <v-list-item-content><v-list-item-title class="font-weight-medium">Empleados</v-list-item-title></v-list-item-content>
      </v-list-item>
      <v-list-item link to='/client/fiscal-auditor-documents' v-if="$can('Clientes - Documentos Revisor Fiscal')">
        <v-list-item-icon><v-icon>mdi-file-document-multiple</v-icon></v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-medium">Documentos Revisor Fiscal</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <!-- GESTIÓN -->
    <v-list class="pa-0 ma-0 white--text"  v-if="($can('Contabilidad - Carga Nómina') || $can('Contabilidad - Ingresos y Retenciones') || $can('Contabilidad - Generación Nómina') || $can('Contabilidad - Documentos Revisor Fiscal') || $can('Contabilidad - Observaciones') || $can('RRHH - Novedades') || $can('Cartas Díarias') || $can('PILA - Pila Electrónico') || $can('Stock - Productos') || $can('Stock - Presupuestos') || $can('Stock - Pedidos') || $can('Stock - Órdenes de Pedido') || $can('Stock - Tareas') || $can('Stock - Reportes'))">
      <v-subheader class="third--text font-weight-medium">Gestión</v-subheader>
      <v-divider inset></v-divider>

      <!-- CONTABILIDAD (Grupo) -->
      <v-list-group
          :value="false"
          prepend-icon="mdi-calculator"
          color="white"
          no-action
          v-if="($can('Contabilidad - Carga Nómina') || $can('Contabilidad - Ingresos y Retenciones') || $can('Contabilidad - Generación Nómina') || $can('Contabilidad - Documentos Revisor Fiscal') || $can('Contabilidad - Observaciones') || $can('Contabilidad - Generación Loggro'))"
      >
        <template v-slot:activator>
          <v-list-item-title class="font-weight-medium">Contabilidad</v-list-item-title>
        </template>
        <v-list-item link to='/accounting/payroll-generation' v-if="$can('Contabilidad - Generación Nómina')">
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">Generación Nómina</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to='/accounting/payrolls' v-if="$can('Contabilidad - Carga Nómina')">
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">Carga Nómina</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to='/accounting/work-incomes' v-if="$can('Contabilidad - Ingresos y Retenciones')">
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">Ingresos y Retenciones</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to='/accounting/notes' v-if="$can('Contabilidad - Observaciones')">
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">Observaciones</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to='/accounting/fiscal-auditor-documents' v-if="$can('Contabilidad - Documentos Revisor Fiscal')">
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">Documentos Revisor Fiscal</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to='/accounting/loggro' v-if="$can('Contabilidad - Generación Loggro')">
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">Reportes Loggro</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <!-- RR.HH. (Grupo) -->
      <v-list-group
          :value="false"
          prepend-icon="mdi-account-tie"
          color="white"
          no-action
          v-if="($can('RRHH - Novedades') || $can('Cartas Díarias'))"
      >
        <template v-slot:activator>
          <v-list-item-title class="font-weight-medium">RR.HH.</v-list-item-title>
        </template>
        <v-list-item link to='/hr/events' exact v-if="$can('RRHH - Novedades')">
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">Novedades</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to='/hr/daily-letters' exact v-if="$can('RRHH - Cartas Diarias')">
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">Cartas Diarias</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <!-- PILA (Grupo) -->
      <v-list-group
          :value="false"
          prepend-icon="mdi-file-chart"
          color="white"
          no-action
          v-if="$can('PILA - Pila Electrónico')"
      >
        <template v-slot:activator>
          <v-list-item-title class="font-weight-medium">PILA</v-list-item-title>
        </template>
        <v-list-item link to='/pila/reports' exact v-if="$can('PILA - Pila Electrónico')">
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">Reportes</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <!-- STOCK (Grupo) -->
      <v-list-group
          :value="false"
          prepend-icon="mdi-package-variant-closed"
          color="white"
          no-action
          v-if="($can('Stock - Productos') || $can('Stock - Presupuestos') || $can('Stock - Pedidos') || $can('Stock - Órdenes de Pedido') || $can('Stock - Tareas') || $can('Stock - Reportes'))"
      >
        <template v-slot:activator>
          <v-list-item-title class="font-weight-medium">Stock</v-list-item-title>
        </template>
        <!-- El orden sigue el proceso real del mes: primero se configura el catálogo y los
             conjuntos, luego el supervisor pide, después compras cierra, se generan las
             tareas de bodega y al final se consultan los saldos y reportes. -->
        <v-list-item link to='/admin/products' exact v-if="$can('Stock - Productos')">
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">Productos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to='/admin/client-stock' exact v-if="$can('Stock - Presupuestos')">
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">Conjuntos y Presupuestos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to='/stock/orders' exact v-if="$can('Stock - Pedidos')">
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">Pedidos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to='/stock/purchase-orders' exact v-if="$can('Stock - Órdenes de Pedido')">
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">Órdenes de Pedido</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to='/stock/tasks' exact v-if="$can('Stock - Tareas')">
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">Tareas de Bodega</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to='/stock/reports' exact v-if="$can('Stock - Reportes')">
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">Saldos y Reportes</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>
    <!-- COMPROBANTES Y CERTIFICADOS -->
    <v-list class="pa-0 ma-0 white--text"  v-if="($can('Certificados - Comprobante de pago') || $can('Certificados - Certificado laboral') || $can('Certificados - Ingresos y Retenciones') || $can('Certificados - PILA'))">
      <v-subheader class="third--text font-weight-medium">Comprobantes y Certificados</v-subheader>
      <v-divider inset></v-divider>
      <v-list-item link to='/certificates/payroll' exact v-if="$can('Certificados - Comprobante de pago')">
        <v-list-item-icon><v-icon>mdi-currency-usd</v-icon></v-list-item-icon>
        <v-list-item-content><v-list-item-title class="font-weight-medium">Comprobante de pago</v-list-item-title></v-list-item-content>
      </v-list-item>
      <v-list-item link to='/certificates/labor' exact v-if="$can('Certificados - Certificado laboral')">
        <v-list-item-icon><v-icon>mdi-receipt-text</v-icon></v-list-item-icon>
        <v-list-item-content><v-list-item-title class="font-weight-medium">Certificado laboral</v-list-item-title></v-list-item-content>
      </v-list-item>
      <v-list-item link to='/certificates/work-income' exact v-if="$can('Certificados - Ingresos y Retenciones')">
        <v-list-item-icon><v-icon>mdi-file-document</v-icon></v-list-item-icon>
        <v-list-item-content><v-list-item-title class="font-weight-medium">Ingresos y Retenciones</v-list-item-title></v-list-item-content>
      </v-list-item>
      <v-list-item link to='/certificates/pila' exact v-if="$can('Certificados - PILA')">
        <v-list-item-icon><v-icon>mdi-hospital-box-outline</v-icon></v-list-item-icon>
        <v-list-item-content><v-list-item-title class="font-weight-medium">PILA</v-list-item-title></v-list-item-content>
      </v-list-item>
    </v-list>

  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'AppDrawer',
  props: {
    showDrawer: Boolean
  },
  data(){
    return{
      mini: false,
      drawer: true
    }
  },
  watch:{
    showDrawer(){
      this.drawer = !this.drawer;
    }
  }
}
</script>